import { getGeometryBBox, wgs84toWebMercator } from './helper';
import LinearScale from '../../scale/linear';
import { alignBox } from '../../utils/boxLayout';
/**
 * export
 */
var Geo = /** @class */ (function () {
    function Geo(boundingRect, geoJson) {
        this.coordinateSystem = 'geo';
        this.dimensions = ['lng', 'lat'];
        this._boundingRect = boundingRect;
        this._geoJSON = geoJson;
        this._initScale();
    }
    Geo.prototype.dataToCoord = function (data) {
        return data;
    };
    Geo.prototype.coordToPoint = function (coord) {
        var _a = wgs84toWebMercator(coord.lng, coord.lat), x = _a[0], y = _a[1];
        return {
            x: this._lngScale.scale(x),
            y: this._latScale.scale(y),
        };
    };
    Geo.prototype.pointToCoord = function (x, y) {
        return {
            lng: this._lngScale.invert(x),
            lat: this._latScale.invert(y),
        };
    };
    Geo.prototype.dataToPoint = function (data) {
        return this.coordToPoint(this.dataToCoord(data));
    };
    Geo.prototype.coordToData = function (coord) {
        return coord;
    };
    Geo.prototype.recordToCoord = function (record, dataIndex, encode) {
        var lng = encode.lng, lat = encode.lat;
        return { lng: lng, lat: lat };
    };
    Geo.prototype.recordToPoint = function (record, dataIndex, encode) {
        return this.coordToPoint(this.recordToCoord(record, dataIndex, encode));
    };
    // eslint-disable-next-line no-unused-vars
    Geo.prototype.valueToCoord = function (value, dataIndex) {
        return null;
    };
    Geo.prototype.getCategoryAxis = function () {
        return null;
    };
    Geo.prototype.getValueAxis = function () {
        return null;
    };
    Geo.prototype._initScale = function () {
        var _a = getGeometryBBox(this._geoJSON), _b = _a[0], minLong = _b[0], maxLong = _b[1], _c = _a[1], minLat = _c[0], maxLat = _c[1];
        var minRange = wgs84toWebMercator(minLong, minLat);
        var maxRange = wgs84toWebMercator(maxLong, maxLat);
        var minX = Math.min(minRange[0], maxRange[0]);
        var maxX = Math.max(minRange[0], maxRange[0]);
        var minY = Math.min(minRange[1], maxRange[1]);
        var maxY = Math.max(minRange[1], maxRange[1]);
        var width = this._boundingRect.width;
        var height = this._boundingRect.height;
        var ration = (maxY - minY) / (maxX - minX);
        if (this._boundingRect.height / this._boundingRect.width >= ration) {
            height = this._boundingRect.width * ration;
        }
        else {
            width = this._boundingRect.height / ration;
        }
        var _d = alignBox(this._boundingRect, width, height, 'center', 'middle'), x = _d.x, y = _d.y;
        this._lngScale = new LinearScale(minX, maxX, x, x + width);
        this._latScale = new LinearScale(minY, maxY, y + height, y);
    };
    return Geo;
}());
export default Geo;
